module.exports = __webpack_public_path__ + "static/media/talent-benefit-easy@3x.ac9e673d.png";